import { render, staticRenderFns } from "./hot-subject.vue?vue&type=template&id=70985348&scoped=true&"
import script from "./hot-subject.vue?vue&type=script&lang=js&"
export * from "./hot-subject.vue?vue&type=script&lang=js&"
import style0 from "./hot-subject.vue?vue&type=style&index=0&id=70985348&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70985348",
  null
  
)

export default component.exports